"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const IS_1 = __importDefault(require("./IS"));
class JSX {
}
exports.default = JSX;
//? ---------------------- Static methods --------------------------------------------------------
JSX.classes = (...entries) => {
    let className = '';
    for (const e of entries) {
        if (!e)
            return;
        if (IS_1.default.string(e))
            return (className += e + ' ');
        className += Object.entries(e || {})
            .filter(p => p[1] === true)
            .map(p => p[0])
            .join(' ');
    }
    className = className === null || className === void 0 ? void 0 : className.trim();
    return { className };
};
